import { Intl } from 'Roblox';
import accountSettingsModule from '../accountSettingsModule';

function formFieldsMappingService($log, languageResource) {
  'ngInject';

  const intl = Intl && new Intl();
  const getLang = languageResource.get;
  const labels = {
    everyone: getLang('Label.DropDown.Everyone'),
    followers: getLang('Label.DropDown.Followers'),
    following: getLang('Label.DropDown.Following'),
    friends: getLang('Label.DropDown.Friends'),
    noOne: getLang('Label.DropDown.NoOne'),
    default: getLang('Label.DropDown.Default'),
    custom: getLang('Label.DropDown.Custom'),
    off: getLang('Label.DropDown.Off'),
    none: getLang('Label.DropDown.None'),
    high: getLang('Label.DropDown.High'),
    medium: getLang('Label.DropDown.Medium'),
    low: getLang('Label.DropDown.Low'),
    themes: {
      dark: getLang('Label.DarkTheme'),
      classic: getLang('Label.ClassicTheme'),
      light: getLang('Label.LightTheme')
    }
  };

  return {
    years: [],
    days: [],
    months: languageResource.intl.getMonthsList(),
    monthsI18n: intl
      ? intl.getMonthsI18n('short', getLang('Label.Month'))
      : languageResource.intl.getMonthsList(),
    privacy: [
      { name: labels.everyone, value: 'All' },
      { name: labels.followers, value: 'Followers' },
      { name: labels.following, value: 'Following' },
      { name: labels.friends, value: 'Friends' },
      { name: labels.noOne, value: 'NoOne' }
    ],
    visibility: [
      { name: labels.everyone, value: 'AllUsers' },
      { name: labels.followers, value: 'FriendsFollowingAndFollowers' },
      { name: labels.following, value: 'FriendsAndFollowing' },
      { name: labels.friends, value: 'Friends' },
      { name: labels.noOne, value: 'NoOne' }
    ],
    under13Privacy: [
      { name: labels.friends, value: 'Friends' },
      { name: labels.noOne, value: 'NoOne' }
    ],
    under13JoinPrivacy: [
      { name: labels.following, value: 'Following' },
      { name: labels.friends, value: 'Friends' },
      { name: labels.noOne, value: 'NoOne' }
    ],
    contactSettingsConfiguration: [
      { name: labels.default, value: 'Default' },
      { name: labels.custom, value: 'Custom' },
      { name: labels.off, value: 'Off' }
    ],
    messaging: [
      { name: labels.everyone, value: 'All' },
      { name: labels.followers, value: 'Followers' },
      { name: labels.following, value: 'Following' },
      { name: labels.friends, value: 'Friends' },
      { name: labels.noOne, value: 'NoOne' }
    ],
    appChat: [
      { name: labels.friends, value: 'Friends' },
      { name: labels.noOne, value: 'NoOne' }
    ],
    phoneNumberDiscovery: [
      { name: labels.everyone, value: 'AllUsers' },
      { name: labels.noOne, value: 'NoOne' }
    ],
    gameChat: [
      { name: labels.everyone, value: 'AllUsers' },
      { name: labels.noOne, value: 'NoOne' }
    ],
    tradeValue: [
      { name: labels.none, value: 'None' },
      { name: labels.low, value: 'Low' },
      { name: labels.medium, value: 'Medium' },
      { name: labels.high, value: 'High' }
    ],
    themes: [
      { name: labels.themes.dark, value: 'Dark' },
      { name: labels.themes.light, value: 'Light' }
    ],
    gender: {
      MALE: '2',
      FEMALE: '3'
    }
  };
}

accountSettingsModule.factory('formFieldsMappingService', formFieldsMappingService);

export default formFieldsMappingService;
